import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { urls } from "../../endPoints";
import { doPost } from "../../../config/fetchWrapper";

export const createPlaybookBatch = createAsyncThunk("createPlaybookBatch",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.createPlaybookBatch, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const PrefillPlaybookSourceYearAction = createAsyncThunk("prefillPlaybookSourceYear",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.playbookSourceYearUpdate, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const createPlaybookQuestions = createAsyncThunk("createPlaybookQuestions",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.createPlaybookQuestions, arg)
            return response;
        } catch (error) {
            rejectWithValue(error)
        }
    }
)

export const createPlaybookBatchSlice = createSlice({
    name: "createPlaybookBatch",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false,
    },
    reducers: {
        createPlaybookBatchReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            }
        }
    },
    extraReducers: {
        [createPlaybookBatch.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [createPlaybookBatch.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [createPlaybookBatch.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.data = false;
        }
    }
})

export const PrefillPlaybookSourceYearSlice = createSlice({
    name: "prefillPlaybookSourceYear",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false,
    },
    reducers: {
        PrefillPlaybookSourceYearReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            }
        }
    },
    extraReducers: {
        [PrefillPlaybookSourceYearAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [PrefillPlaybookSourceYearAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [PrefillPlaybookSourceYearAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.data = false;
        }
    }
})

export const { createPlaybookBatchReset } = createPlaybookBatchSlice.actions;
export const { PrefillPlaybookSourceYearReset } = PrefillPlaybookSourceYearSlice.actions;
